import { render } from "./EditNormalizedScoresFunctions.vue?vue&type=template&id=5194b4dd&ts=true"
import script from "./EditNormalizedScoresFunctions.vue?vue&type=script&lang=ts"
export * from "./EditNormalizedScoresFunctions.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__